import { Input, Button, IconButton, Icon, Tooltip } from "./ui";
import { useState, useEffect } from "react";

// Helper function to format numbers without unnecessary trailing zeros
const formatNumber = (num) => {
    // Round to 1 decimal, then convert to number to remove trailing zeros
    return Number(num.toFixed(1));
};

const WallEdit = (props) => {

    const [wallHeight, setWallHeight] = useState(props.floorplanningHelper.wallHeight);
    const [wallLength, setWallLength] = useState(Math.round(props.floorplanningHelper.wallLength));
    const [currentWallId, setCurrentWallId] = useState(props.floorplanningHelper.__selectedWall?.id);

    // Only reset state when a different wall is selected (by checking wall ID)
    useEffect(() => {
        const selectedWallId = props.floorplanningHelper.__selectedWall?.id;
        if (selectedWallId && selectedWallId !== currentWallId) {
            setWallLength(Math.round(props.floorplanningHelper.wallLength));
            setCurrentWallId(selectedWallId);
        }
    }, [props.floorplanningHelper.__selectedWall?.id]);

    const setWallThickness = (newThickness) => {
        props.floorplanningHelper.wallThickness = newThickness;
    }

    const updateWallLength=( direction, newDistance) =>{
        //start and end are the two corner objects of the wall
        let start = props.floorplanningHelper.__selectedWall.start;
        let end = props.floorplanningHelper.__selectedWall.end;

        let newDistanceinCM = newDistance; // newDistance is already in centimeters

        let left;
        let right;
        let up;
        let down;

        if (direction === "both") {//both corner must move
            let difference = newDistanceinCM - (start._co.distanceTo(end._co));//difference between new and old length
            if (difference === 0) {return;}//if the difference is 0 there is no need to modify anyting
            let moveDistance = difference / 2; //each corner must move half the difference;
            let vec = start._co.clone();//clone to not modify the original
            vec.sub(end._co);//get a direction instead of a point
            vec.normalize();//make a unitary direction
            vec.multiplyScalar(moveDistance);//set the length of the direction
            let vec2 = vec.clone();//make a new direction
            vec2.negate();//this new direction will be in the opposite direction
            vec.add(start._co);//add direction with the point to get a new point (new position of the corner)
            start.move(vec.x, vec.y)//set the new coordinate of the corner
            vec2.add(end._co)//add the other direction with the other point to get the new point
            end.move(vec2.x, vec2.y);//set the coordinate of the other corner
        } else {//only one corner must move
            if (start._x < end._x) {//decide wich corner is the right one and wich one is the left one
                left = start;
                right = end;
            } else {
                left = end;
                right = start;
            }
            if (start._y < end._y) {//decide the upper and lower corner
                down = end;
                up = start;
            } else {
                down = start;
                up = end;
            }
            let vec;
            switch (direction) {//TODO there is some code repetition, a helper function could be used
                case "right"://only the right corner moove
                    vec = right._co.clone();//clone the vector so to not modify the original
                    vec.sub(left._co);//subtract to obtain a direction instead of a point
                    vec.normalize();//normalize to get a unitary direction
                    vec.multiplyScalar(newDistanceinCM);//set the length of the direction
                    vec.add(left._co);//add the point to the direction to obtain the new point
                    right.move(vec.x, vec.y);//set the corner to its new position
                    break;
                case "left"://only the left corner move
                    vec = left._co.clone();
                    vec.sub(right._co);
                    vec.normalize();
                    vec.multiplyScalar(newDistanceinCM);
                    vec.add(right._co);
                    left.move(vec.x, vec.y);
                    break;
                case "down"://only the down corner move
                    vec = down._co.clone();
                    vec.sub(up._co);
                    vec.normalize();
                    vec.multiplyScalar(newDistanceinCM);
                    vec.add(up._co);
                    down.move(vec.x, vec.y);
                    break;
                case "up"://only the upper corner move
                    vec = up._co.clone();
                    vec.sub(down._co);
                    vec.normalize();
                    vec.multiplyScalar(newDistanceinCM);
                    vec.add(down._co);
                    up.move(vec.x, vec.y);
                    break;
                default:
                    console.log("invalid direction in function updateWallLength")
                    break;
            }
        }
        
        // Update the wallLength property in floorplanningHelper after modification
        props.floorplanningHelper.wallLength = newDistanceinCM;
        
        // Update local state to reflect the new actual length (in cm)
        setWallLength(newDistance);
        
        props.updateFloorplan();
    }

    const deleteSelf = ()=>{
        props.floorplanningHelper.deleteCurrentItem();
        props.resetSelected2DEntity();
    }

    //return true if the wall has an angle > 45 degree
    const isVertical = () => {
        let start = props.floorplanningHelper.__selectedWall.start._co;
        let end = props.floorplanningHelper.__selectedWall.end._co;
        var dy = end.y - start.y;
        var dx = end.x - start.x;
        var theta = Math.atan2(dy, dx);
        theta *= 180 / Math.PI;
        if ((theta <= 45 && theta >= 0) || (theta >= -45 && theta < 0) || (theta <= 180 && theta >= 135) || (theta >= -180 && theta < -135)  ) {
            return false;
        } else {
            return true;
        }
    }

    const horizontalStyle = {
        display: "flex",
        alignItems: "stretch",
        justifyContent: "center",
        flexDirection : "row",
    }

    const verticalStyle = {
        width: "50%",
        margin: "0 auto",
    }

    const renderButtons = () => {
        if (isVertical()){
            return (
                <div style={verticalStyle}>
                    <Tooltip text="Adjust to this side" position="top">
                        <IconButton size="medium" onClick={()=>{updateWallLength("up", wallLength)}}> 
                            <Icon size="16px" name="ArrowTopIcon" />
                        </IconButton>
                    </Tooltip>
                    <Tooltip text="Adjust to both sides" position="top">
                        <IconButton size="medium" onClick={()=>{updateWallLength("both", wallLength)}}> 
                            <Icon size="16px" name="ScaleIcon" />
                        </IconButton>
                    </Tooltip>
                    <Tooltip text="Adjust to this side" position="top">
                        <IconButton size="medium" onClick={()=>{updateWallLength("down", wallLength)}}> 
                            <Icon size="16px" name="ArrowBottomIcon" />
                        </IconButton>
                    </Tooltip>
                    {/* <Button onClick={()=>{updateWallLength("up", wallLength)}}>Modify up</Button>
                    <Button onClick={()=>{updateWallLength("down", wallLength)}}>Modify down</Button> */}
                </div>
            )
        } else {
            return (
                <div style={horizontalStyle}>
                    <Tooltip text="Adjust to this side" position="bottom">
                        <IconButton size="medium" onClick={()=>{updateWallLength("left", wallLength)}}> 
                            <Icon size="16px" name="ArrowLeftIcon" />
                        </IconButton>
                    </Tooltip>
                    <Tooltip text="Adjust to both sides" position="bottom">
                        <IconButton size="medium" onClick={()=>{updateWallLength("both", wallLength)}}> 
                            <Icon size="16px" name="ScaleIcon" />
                        </IconButton>
                    </Tooltip>
                    <Tooltip text="Adjust to this side" position="bottom">
                        <IconButton size="medium" onClick={()=>{updateWallLength("right", wallLength)}}> 
                            <Icon size="16px" name="ArrowRightIcon" />
                        </IconButton>
                    </Tooltip>
                    {/* <Button onClick={()=>{updateWallLength("left", wallLength)}}>Modify left</Button>
                    <Button onClick={()=>{updateWallLength("right", wallLength)}}>Modify right</Button> */}
                </div>
            )
        }
    }

    return (
        <div style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
            alignItems: "center",
            flexDirection : "column",
            width: "180px",
            padding: "10px",
            gap: "5px",
        }}>
            <label style={{ fontSize: "12px", alignSelf: "flex-start", marginBottom: "-2px" }}>
                Wall length (cm)
            </label>
            <Input type="number"
                value={formatNumber(wallLength)}
                onChange={(evt)=>{
                    const value = parseFloat(evt.target.value);
                    const roundedValue = Math.round(value * 10) / 10;
                    setWallLength(isNaN(roundedValue) ? 0 : roundedValue);
                }}
                step={1}
            />
            {renderButtons()}

            <div></div>
            <div></div>
            <div></div>

            <label style={{ fontSize: "12px", alignSelf: "flex-start", marginBottom: "-2px" }}>
                Wall thickness (cm)
            </label>
            <Input type="number"
                min={0}
                max={200}
                step={1}
                value={formatNumber(props.floorplanningHelper.wallThickness)}
                onChange={(evt) => { setWallThickness(evt.target.value) }} />

            {/* probably this is not the right place to put this as we want global wall height
            <Input type="number"
                placeholder="Wall height (cm)"
                min={0}
                max={2000}
                step={1}
                value={props.floorplanningHelper.wallHeight}
                onChange={(evt) => { setWallHeight(evt.target.value) }} />
            */}
            
            <div></div>
            <div></div>
            <div></div>

            <Button color="red" onClick={()=>{deleteSelf()}}>Delete Wall</Button>
        </div>
    )
}

export default WallEdit;